import React from 'react';

function ApplyModeContent() {
  return (
    <>
      <p>Apply Mode is a powerful feature that lets you take code changes suggested by external AI services (like ChatGPT web interface or Claude) and apply them directly to your local files.</p>
      
      <h3>When to Use Apply Mode</h3>
      <p>Apply Mode is ideal when:</p>
      <ul>
        <li>You're using a web-based AI interface rather than RepoPrompt's integrated chat</li>
        <li>You have existing conversations with AI services that you want to implement</li>
        <li>You prefer using specific external AI services for certain tasks</li>
      </ul>
      
      <h3>The XML Diff Format</h3>
      <p>For Apply Mode to work, the AI response must use a specific XML format that includes:</p>
      <ul>
        <li><code>&lt;plan&gt;</code>: Overall explanation of the changes</li>
        <li><code>&lt;file&gt;</code>: Container for changes to a specific file</li>
        <li><code>&lt;change&gt;</code>: Individual edit within a file</li>
        <li><code>&lt;search&gt;</code>: The original code to find</li>
        <li><code>&lt;content&gt;</code>: The new code to replace it with</li>
      </ul>
      
      <h3>Asking the AI for the Correct Format</h3>
      <ol>
        <li>In the "Apply" tab, select the files relevant to your task</li>
        <li>Enter your instructions in the "Instructions" text area</li>
        <li>Click the "Copy with Diff Edit Prompt" button</li>
        <li>Paste the complete prompt into your external AI service</li>
        <li>This prompt includes special instructions that ask the AI to respond using the required XML format</li>
      </ol>
      
      <h3>Applying AI Suggestions</h3>
      <ol>
        <li>Once the AI responds with XML-formatted changes, copy the entire response</li>
        <li>In RepoPrompt, click the "Apply" tab</li>
        <li>Paste the AI response into the "AI Response" text area on the right side</li>
        <li>Click the "Merge Changes" button</li>
        <li>RepoPrompt will parse the XML and display the proposed changes in a diff review screen</li>
        <li>Review each change carefully</li>
        <li>Click "Accept All Files" to apply all changes, or review and accept individual files</li>
        <li>Click "Reset All Files" to discard all changes</li>
        <li>Click "Exit Review" when done</li>
      </ol>
      
      <h3>Troubleshooting Apply Mode</h3>
      <p>If the AI response doesn't parse correctly:</p>
      <ul>
        <li>Ensure the response contains the proper XML tags (<code>&lt;plan&gt;</code>, <code>&lt;file&gt;</code>, etc.)</li>
        <li>Check that file paths in the response match your actual project structure</li>
        <li>Verify that the <code>&lt;search&gt;</code> blocks exactly match portions of your actual files</li>
        <li>Try using the "Copy with Diff Edit Prompt" button again to generate a clearer prompt</li>
      </ul>
      
      <div className="tip-box">
        <strong>Tip:</strong> For complex edits across multiple files, you may get better results by breaking your request into smaller chunks, focusing on related files in each request.
      </div>
    </>
  );
}

export default ApplyModeContent;